export default __webpack_public_path__ + "static/home-bddab5634860f8ec61408c38a10cb2e3.png";